/**
 * Classificação é derivada pelo backend a partir do sufixo de W07USUCOD
 * (CX → Caixa, GE → Gerente, demais → "-") e chega pronta no DTO
 * `IStoreOperatorRecord.classification`.
 */
export type OperatorClassificationValue = "Caixa" | "Gerente" | "-";

export interface OperatorClassificationOption {
  value: OperatorClassificationValue;
  label: string;
}

/**
 * Opções do dropdown de classificação. Label inclui o código entre parênteses
 * para que quem conhece o sistema pelo sufixo (CX, GE) também reconheça.
 */
export const OPERATOR_CLASSIFICATION_OPTIONS: OperatorClassificationOption[] = [
  { value: "Caixa", label: "Caixa (CX)" },
  { value: "Gerente", label: "Gerente (GE)" },
  { value: "-", label: "Indefinido (-)" },
];

export interface SituationOption {
  value: string;
  label: string;
}

/**
 * Valores de SITUACAO conhecidos no Sênior — alinhados com o enum canônico
 * `EmployeeSituation` em `src/constants/employee-situation.ts`. Backend aceita
 * qualquer valor via passthrough; a lista aqui é só a UX do dropdown.
 */
export const SITUATION_OPTIONS: readonly SituationOption[] = [
  { value: "1. Trabalhando", label: "Trabalhando" },
  { value: "2. Férias", label: "Férias" },
  { value: "3. Auxílio Doença", label: "Auxílio Doença" },
  { value: "6. Licença Maternidade", label: "Licença Maternidade" },
  { value: "7. Demitido", label: "Demitido" },
  { value: "10. Lic. Rem. p/ Funcion.", label: "Licença Remunerada" },
  { value: "122. Aposentadoria p/ Invalidez", label: "Aposentadoria por Invalidez" },
] as const;
